import React, { Component } from 'react';
import Card from './Card';
import OpenStreetMapChoropleth from './OpenStreetMapChoropleth';


class MapCardChoropleth extends Component {


  render() {

      return (
        <Card body={
            <OpenStreetMapChoropleth
              markers={this.props.markers ?  this.props.markers : [] }
              polylines={this.props.polylines ? this.props.polylines : [] }
              polygons={this.props.polygons ? this.props.polygons : [] }
              markerTitle={this.props.markerTitle}
              markerPopupColumns={this.props.markerPopupColumns}
              mapPositionLat={this.props.mapPositionLat}
              mapPositionLng={this.props.mapPositionLng}
              mapZoomLevel={this.props.mapZoomLevel}
              latName={this.props.latName}
              lonName={this.props.lonName}
              geojson={this.props.geojson}
              onMapMoveBounds={this.props.onMapMoveBounds}
              mapMinZoom={this.props.mapMinZoom}
              getPolygonColor={this.props.getPolygonColor}
              ></OpenStreetMapChoropleth>
          }>
        </Card>
	     )
  }
}

export default MapCardChoropleth;
